/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

import { parse, stringify } from '@vanillaes/csv'

const COL_LOGNR = 0;
const CLOCKSTART = 1;
const COL_ENDCALCCLOCK = 2;
const COL_CORGPSX = 5;
const COL_CORGPSY = 6;
const COL_HEADING2ATAN2 = 10;
const COL_LINEFOUND0 = 170;
const COL_LINEFOUND1 = 171;
const COL_LINEFOUND2 = 172;
const COL_LINEFOUND3 = 173;
const COL_LINEFOUND4 = 174;
const COL_LINEFOUND5 = 175;
const COL_LINEFOUND6 = 176;
const COL_LINEFOUND7 = 177;




class LogLine {
    lidarlog = null;

    constructor(loglinearray) {
        this.logline = loglinearray;
    }

    get Lognr() {
        return parseInt(this.logline[COL_LOGNR]);
    }

    get EndCalcClock() {
        return parseFloat(this.logline[COL_ENDCALCCLOCK]);
    }
    get CorGPSX() {
        return parseFloat(this.logline[COL_CORGPSX]);
    }
    get CorGPSY() {
        return parseFloat(this.logline[COL_CORGPSY]);
    }
    get Heading2Atan2() {
        return parseFloat(this.logline[COL_HEADING2ATAN2]);
    }

    get MachineLine1() {
        if (this.logline.length >= 178)
            return [{
                x: parseFloat(this.logline[COL_LINEFOUND0]),
                y: parseFloat(this.logline[COL_LINEFOUND1])
            },
            {
                x: parseFloat(this.logline[COL_LINEFOUND2]),
                y: parseFloat(this.logline[COL_LINEFOUND3])
            }];
        else
            return null;
    }

    get MachineLine2() {
        if (this.logline.length >= 178)
            return [{
                x: parseFloat(this.logline[COL_LINEFOUND4]),
                y: parseFloat(this.logline[COL_LINEFOUND5])
            },
            {
                x: parseFloat(this.logline[COL_LINEFOUND6]),
                y: parseFloat(this.logline[COL_LINEFOUND7])
            }];
        else
            return null;
    }

    setLidarLog(lidarlog) {
        this.lidarlog = lidarlog;
    }
}

export default class Datalog {
    #parsed;
    #parsedArray = [];

    constructor(datalog) {
        this.datalog = datalog;
        this.headerarray = [];
        this.data = [];
        this.projectionId = null


        if (Array.isArray(datalog)) {
            //array of datalogs, merge datalogs
            console.log('is array');
            this.mergeDatalogs();

        } else {
            this.#parsed = parse(this.datalog);
            this.parseDatalog();
        }
    }

    parseDatalog() {
        // line 1
        if (this.#parsed[0].length != 84)
            console.log("Datalog line 1, expected 84 items, got: " + this.#parsed[0].length + " lines");

        this.projectionId = this.#parsed[0][45];
        // line 2
        if (this.#parsed[1].length != 2)
            console.log(this.#parsed[1].length);

        this.headerarray.push(this.#parsed[0])
        this.headerarray.push(this.#parsed[1])

        var line = 2;
        for (; line < this.#parsed.length; line++) {
            this.data.push(new LogLine(this.#parsed[line]));
        }
    }

    mergeDatalogs() {
        this.#parsed = []
        this.datalog.forEach(datalogItem => {
            this.#parsedArray.push(parse(datalogItem));
        });

        this.#parsedArray.sort((a, b) => a[2][2] - b[2][2]);

        this.#parsed.push(this.#parsedArray[0][0],this.#parsedArray[0][1]);

        this.#parsedArray.forEach(parsedLogItem => {
            parsedLogItem.shift(); parsedLogItem.shift()
            this.#parsed.push(...parsedLogItem);
        })

        this.parseDatalog();
    }

    getDatalogString() {
        var datalogArray = parse(stringify(this.headerarray));
        this.data.forEach(logLine => {
            datalogArray.push(logLine.logline);
        });
        return stringify(datalogArray);
    }
}